/**
 * Production no-op replacement for MSW's browser worker (`@mocks/browser`).
 *
 * MSW (Mock Service Worker) is a development-only mocking tool. In production it
 * must never run, yet `react-component-registry` statically references
 * `require('@mocks/browser')`, which forces webpack to bundle MSW and its heavy
 * transitive dependencies (psl's public-suffix list, tough-cookie, the
 * @mswjs/interceptors stack) into clientlib-site / searchresults / filterbar.
 *
 * `webpack.prod.js` swaps `@mocks/browser` for this stub via
 * NormalModuleReplacementPlugin so none of that ships to production. Dev builds
 * (webpack.dev.js) are unaffected and load the real worker.
 */
module.exports = {
  worker: {
    start() {
      return Promise.resolve()
    },
  },
}
